<template>
  <v-app>
    <app-global-error v-if="globalError"></app-global-error>
    <div v-else>
      <app-layout-authenticated v-if="userIsAuthenticated"></app-layout-authenticated>
      <app-layout-unauthenticated v-else></app-layout-unauthenticated>
    </div>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      sideNav: false
    }
  },
  computed: {
    globalError () {
      return this.$store.getters.globalError
    },
    user () {
      return this.$store.getters.user
    },
    userIsAuthenticated () {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      )
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style>
html {
  font-size: 12pt;
}
.v-content__wrap {
  background-color: #ffffff;
}
.v-small-dialog {
  display: inline-block;
  width: initial;
  text-decoration: underline;
}
.v-small-dialog a {
  color: teal !important;
}
.inline-date {
  display: inline-block;
  margin: 0;
  max-width: 90px;
}
.inline {
  display: inline-block !important;
  margin: 0;
}
.inline .v-input__slot {
  margin: 0 !important;
}

:target::before {
  content: "";
  display: block;
  height: 200px;
  margin: -60px 0 0;
}
.v-radio {
  margin-right: 0 !important;
  vertical-align: bottom;
}
.v-input--selection-controls.v-input .v-label {
  color: rgba(0,0,0,0.87);
}
.time-input {
  width: 80px;
}
hr.dashed {
  border-color: #dedede;
  border-style: dashed;
  margin: 15px 30px;
}
.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
}
.toolbar {
  top: 64px !important;
}
@media (max-width: 960px) {
  .toolbar {
    top: 56px !important;
  }
}
</style>
